"use client";

import Image from "next/image";
import Link from "next/link";
import { Trans, useTranslation } from "react-i18next";
import { usePathname } from "next/navigation";
import { getLocaleFromPath } from "../lib/i18n/utils";

export default function HomeHero() {
  const { t } = useTranslation();
  const pathname = usePathname();
  const locale = getLocaleFromPath(pathname);

  return (
    <section className="relative w-full overflow-hidden h-130 md:h-162.5 lg:h-247.5">
      <Image
        src="/hero.jpg"
        alt={t("To Spiti Tis Sofias")}
        fill
        priority
        className="object-cover object-[50%_70%]"
        sizes="100vw"
      />
      <div className="absolute left-1/2 top-8 -translate-x-1/2 md:top-75 lg:left-32 lg:top-50 lg:translate-x-0">
        <div className="w-[90vw] max-w-172 rounded-[2.5rem] bg-ui-card/90 px-2.5 py-10 text-white -rotate-[3.96deg]">
          <div className="rotate-[3.96deg]">
            <h1 className="text-center font-normal leading-[1.15] text-[clamp(1.75rem,6.2vw,3rem)]">
              {t("To Spiti Tis Sofias")}
            </h1>

            <p className="mt-2.5 text-center font-light leading-tight text-[clamp(1rem,4.2vw,1.875rem)]">
              <Trans
                i18nKey='Just 8 km from the center of Kastoria, where the plain meets the mountains of Grammos, Greek family hospitality finds its magnificent expression at the guesthouse "To Spiti Tis Sofias".'
                components={[
                  <Link
                    key="kastoria"
                    href={locale === "el" ? "/area" : `/${locale}/area`}
                    className="underline hover:text-white/90 transition-colors decoration-white/50 hover:decoration-white"
                  />,
                  <Link
                    key="grammos"
                    href={locale === "el" ? "/area" : `/${locale}/area`}
                    className="underline hover:text-white/90 transition-colors decoration-white/50 hover:decoration-white"
                  />,
                  <Link
                    key="guesthouse"
                    href={locale === "el" ? "/" : `/${locale}`}
                    className="underline hover:text-white/90 transition-colors decoration-white/50 hover:decoration-white"
                  />,
                ]}
              />
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

